import { ColumnPin, View, ViewType } from "@common/types/views/views";

export enum HistoryAccountDetailsColumn {
    TIME = "time",
    IDENTIFIER = "identifier",
    GROUP = "group",
    ENTITY = "entity",
    PREVIOUS = "previous",
    MODIFIED = "modified",
}

export enum HistoryAccountTableKind {
    IDENTITY = "identity",
    CHANGE = "change",
    MERGE = "merge",
    GROUP_DELETE = "groupDelete",
}

export interface HistoryAccountDetailsView extends View {
    type: ViewType.HISTORY_UPDATED_TRANSACTION;
    columns: Array<{
        id: HistoryAccountDetailsColumn;
        options?: { pin?: ColumnPin };
    }>;
}
